import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { extractDomain, getExpDateByDays } from "utils/cookiesUtils";
import { USER_TRACKING_COOKIE_EXPIRATION_DAYS, USER_TRACKING_COOKIE_NAME } from "./config";
import createUserTrackingCookieValue from "./utils/createUserTrackingCookieValue";

export default function useUserTrackingCookie() {
  const [, setCookie] = useCookies([USER_TRACKING_COOKIE_NAME]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const cookieValue = createUserTrackingCookieValue(
      urlParams.get("gclid"),
      urlParams.get("utm_source"),
      urlParams.get("utm_medium")
    );

    if (!cookieValue) return;

    const domain = extractDomain();

    setCookie(USER_TRACKING_COOKIE_NAME, cookieValue, {
      domain,
      path: "/",
      expires: getExpDateByDays(USER_TRACKING_COOKIE_EXPIRATION_DAYS),
    });
  }, [setCookie]);
}
